import { cloneDeep } from 'lodash';
const SET_CATEGORIES = 'SET_CATEGORIES';

const initialState = [];

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_CATEGORIES:
			return [...action.payload];
		default:
			return state;
	}
}

export function setCategories( catagories ){
	return {
		type: SET_CATEGORIES,
		payload: catagories
	}
}



// WEBPACK FOOTER //
// ./src/modules/categories.js